// extracted by mini-css-extract-plugin
export var originalPrice = "_vt-0";